import { dev } from '$app/environment';
import { ApolloLink } from '@apollo/client/link/core/index.js';

export const loggingLink = () =>
  new ApolloLink((operation, forward) => {
    const { operationName, variables } = operation;

    return forward(operation).map(result => {
      if (dev) {
        console.log(`Operation: ${operationName}`, {
          variables,
          data: result.data,
          responseTimeMs: result.extensions?.performance?.elapsed
        });
      }
      return result;
    });
  });
